/* eslint-disable arrow-body-style */
import http from '@/utils/http';

export const getApiData:  (api: string, data: any, errorHandler?:boolean) => Promise<any> = (api, data, errorHandler) => {
  return http({
    url: api,
    method: 'post',
    data,
    errorHandler: errorHandler !== undefined ? errorHandler : true,
  });
};

export const  setApiData = getApiData;